import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const MedicineFields: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const { prescription, storageConditions, concentration, headingColor, textColor, headingFontStyle, fontStyle } = context.product;

  return (
    <>
      {concentration && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Concentration
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {concentration}
          </p>
        </div>
      )}
      {storageConditions && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Storage Condition
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {storageConditions}
          </p>
        </div>
      )}
      {prescription && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Prescription Status
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {prescription}
          </p>
        </div>
      )}
    </>
  );
};

export default MedicineFields;
